
import axios from '../../config/axiosConfig';
import { GET_BANK_PAYMENT_SLIP_ENTRY_TRANSACTIONS, BANK_PAYMENT_SLIP_ENTRY_TRANSACTION_REQUEST, BANK_PAYMENT_SLIP_ENTRY_TRANSACTION_REQUEST_FAILURE } from '../types';

export const getBankPaymentSlipEntryTransactions = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BANK_PAYMENT_SLIP_ENTRY_TRANSACTION_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
            axios.get('/bank-payment-slip-entry/getAllTransactions', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BANK_PAYMENT_SLIP_ENTRY_TRANSACTIONS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_PAYMENT_SLIP_ENTRY_TRANSACTION_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_PAYMENT_SLIP_ENTRY_TRANSACTION_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};